import morph from "../helpers/morph";

class PdpVariantButton extends HTMLElement {
  connectedCallback() {
    this.linkEl = this.closest("[data-variant-link]");
    if (!this.linkEl) return;

    this._handleClick = (e) => {
      e.preventDefault();
      this._selectVariant();
    };

    this.linkEl.addEventListener("click", this._handleClick);
  }

  disconnectedCallback() {
    this.linkEl?.removeEventListener("click", this._handleClick);
  }

  async _selectVariant() {
    const url = new URL(
      this.getAttribute("product-url"),
      window.location.origin,
    );
    const targetSelector = "#MainContent";
    const currentRoot = document.querySelector(targetSelector);
    if (!currentRoot) return;

    try {
      const res = await fetch(url);
      const text = await res.text();

      const doc = new DOMParser().parseFromString(text, "text/html");
      const nextRoot = doc.querySelector(targetSelector);
      if (!nextRoot) return;

      const fragment = document
        .createRange()
        .createContextualFragment(nextRoot.outerHTML);

      morph(currentRoot, fragment);

      if (!window.Shopify?.designMode && this.updateUrl) {
        const cleanUrl = new URL(url);
        cleanUrl.searchParams.delete("section_id");
        history.replaceState({}, "", cleanUrl);
      }
    } catch (e) {
      console.warn("[PDP] variant swap failed", e);
    }
  }

  get updateUrl() {
    return !this.hasAttribute("disable-update-url");
  }
}

if (!customElements.get("pdp-variant-button")) {
  customElements.define("pdp-variant-button", PdpVariantButton);
}
